import { Address } from './address.class';
import { Phone } from './phone.class';
import { Photo } from './photo.class';

export class ContactData {
  address: Address;
  department: string;
  email: string;
  firstName: string;
  id: string;
  lastName: string;
  middleName: string;
  notes: [] | string;
  phones: Phone[];
  photo: Photo;
  sameAddressAsLead?: boolean;
  suffix: string;
  title: string;
  addressToggleCheckbox?: boolean;
  customerId?: string;
  leadId?: string;
  isCreatedFromQuote?: boolean;
}
